/**
 * Plain session storage with fallback to in-memory object.
 * Implements the same method names as the Storage API interface.
 * @implements {Storage}
 */
export class SessionStore {
    constructor() {
        this.isStore = (() => {
            try {
                return !!(window && window.sessionStorage);
            } catch (err) {
                return false;
            }
        })();
        this.plainCache = {};
    }

    /**
     * Save a value for the specified key.
     * @param {string} key
     * @param {string} value
     */
    setItem(key, value) {
        const storedValue = typeof value === typeof ''
            ? value
            : JSON.stringify(value);
        if (this.isStore) {
            window.sessionStorage.setItem(key, storedValue);
        } else {
            Reflect.set(this.plainCache, key, storedValue);
        }
    }

    /**
     * Get the value for the specified key.
     * @param {string} key
     * @returns {*}
     */
    getItem(key) {
        let value;
        if (this.isStore) {
            value = window.sessionStorage.getItem(key);
        } else {
            value = Reflect.get(this.plainCache, key);
        }
        if (value === null) {
            return null;
        }
        try {
            return JSON.parse(value);
        } catch (err) {
            return value;
        }
    }

    /**
     * Delete a key from the cache.
     * @param {string} key
     */
    removeItem(key) {
        if (this.isStore) {
            window.sessionStorage.removeItem(key);
        } else {
            Reflect.deleteProperty(this.plainCache, key);
        }
    }

    /**
     * Reset session memory.
     */
    clear() {
        if (this.isStore) {
            window.sessionStorage.clear();
        } else {
            this.plainCache = {};
        }
    }
}

export default new SessionStore();
